import { Component, input, output } from '@angular/core';
import { AutoclickerDirective } from '../../../directives/autoclicker';

@Component({
  selector: 'lib-number-input',
  templateUrl: './number-input.component.html',
  imports: [AutoclickerDirective],
})
export class NumberInputComponent {
  public readonly label = input<string>();

  public readonly min = input(0);

  public readonly max = input(1);

  public readonly value = input<number>();

  public readonly unit = input<string>();

  public readonly changed = output<number>();

  inc(): void {
    const current = this.value() ?? 0;
    if (current >= this.max()) {
      return;
    }

    this.changed.emit(current + 1);
  }

  dec(): void {
    const current = this.value() ?? 0;
    if (current <= this.min()) {
      return;
    }

    this.changed.emit(current - 1);
  }

  applyValue(event: Event): void {
    const nextValue = Number((event.target as HTMLInputElement).value);

    if (Number.isNaN(nextValue)) {
      return;
    }

    let clamped = nextValue;
    if (clamped < this.min()) clamped = this.min();
    if (clamped > this.max()) clamped = this.max();

    this.changed.emit(clamped);
  }
}
